(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CountryPhoneCodeDialogController', CountryPhoneCodeDialogController);

    CountryPhoneCodeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CountryPhoneCode'];

    function CountryPhoneCodeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CountryPhoneCode) {
        var vm = this;
        vm.countryPhoneCode = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:countryPhoneCodeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.countryPhoneCode.id !== null) {
                CountryPhoneCode.update(vm.countryPhoneCode, onSaveSuccess, onSaveError);
            } else {
                CountryPhoneCode.save(vm.countryPhoneCode, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
